module.exports = __webpack_public_path__ + "static/img/product2.e90166f0.png";